import { useState } from 'react';
import { X } from 'lucide-react';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Email chips input: type an address and press Enter (or comma) to add it.
 * value: array of email strings; onChange receives the updated array.
 */
const EmailTagInput = ({ value = [], onChange, placeholder = 'Add email address…' }) => {
	const [draft, setDraft] = useState('');
	const [invalid, setInvalid] = useState(false);

	const addDraft = () => {
		const email = draft.trim().replace(/,$/, '');
		if (!email) return;
		if (!EMAIL_PATTERN.test(email)) {
			setInvalid(true);
			return;
		}
		if (!value.includes(email)) {
			onChange([...value, email]);
		}
		setDraft('');
		setInvalid(false);
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter' || e.key === ',') {
			e.preventDefault();
			addDraft();
		} else if (e.key === 'Backspace' && !draft && value.length) {
			onChange(value.slice(0, -1));
		}
	};

	const removeEmail = (email) => {
		onChange(value.filter((v) => v !== email));
	};

	return (
		<div>
			<div className='flex flex-wrap items-center gap-1.5 w-full p-2 border border-gray-300 bg-gray-50 min-h-10'>
				{value.map((email) => (
					<span
						key={email}
						className='inline-flex items-center gap-1 bg-gray-200 text-gray-700 px-2 py-0.5 text-sm'
					>
						{email}
						<button
							type='button'
							onClick={() => removeEmail(email)}
							className='text-gray-500 hover:text-gray-900'
							title={`Remove ${email}`}
						>
							<X className='h-3.5 w-3.5' />
						</button>
					</span>
				))}
				<input
					type='email'
					value={draft}
					onChange={(e) => {
						setDraft(e.target.value);
						setInvalid(false);
					}}
					onKeyDown={handleKeyDown}
					onBlur={addDraft}
					placeholder={placeholder}
					className='flex-1 min-w-44 bg-transparent border-none outline-none text-base text-gray-900'
				/>
			</div>
			{invalid && (
				<p className='error text-xs mt-1'>Enter a valid email address.</p>
			)}
		</div>
	);
};

export default EmailTagInput;
